import {ReportRun,} from '../types';
import {Anchor, Stack} from '@mantine/core';
import {
    PlatformPropertyCard,
    PlatformPropertyCardCopyButtonDecorator,
    PlatformPropertyCardProperty,
} from '@flexinet/ui-components';
import {useReportFile} from '../hooks/useReportFile';

export const Profile = ({record}: { record: ReportRun }) => {

    const {reportFile, loading: fileLoading} = useReportFile(record.result || undefined);

    const properties = [
        {
            label: 'Report Run ID',
            value: record.id as string,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        },
        {
            label: 'Report Type',
            value: record.reportType as string,
            span: 12,
        },
        {
            label: 'Status',
            value: record.status as string,
            span: 12,
        },
        {
            label: 'Result',
            value: fileLoading
                ? 'Loading...'
                : reportFile?.url
                    ? <Anchor href={reportFile.url} target="_blank">{reportFile.filename || 'Download'}</Anchor>
                    : record.result || 'N/A',
            span: 12,
        },
        {
            label: 'Error',
            value: record.error as string,
            span: 12,
        }];

    const properties2: PlatformPropertyCardProperty[] = [
        {
            label: 'Created',
            value: record.createdAtMillis,
            formatter: 'timestamp',
            span: 12,
        },
        {
            label: 'Succeeded At',
            value: record.succeededAtMillis,
            formatter: 'timestamp',
            span: 12,
        }];

    const parameterProperties: PlatformPropertyCardProperty[] = record.parameters ? [
        {
            label: 'Currency',
            value: record.parameters.currency as string,
            span: 12,
        },
        {
            label: 'Timezone',
            value: record.parameters.timezone as string,
            span: 12,
        },
        {
            label: 'Reporting Category',
            value: record.parameters.reportingCategory as string,
            span: 12,
        },
        {
            label: 'Connected Account',
            value: record.parameters.connectedAccount as string,
            span: 12,
        },
        {
            label: 'Payout',
            value: record.parameters.payout as string,
            span: 12,
        },
        {
            label: 'Interval Start',
            value: record.intervalStartMillis,
            formatter: 'timestamp',
            span: 12,
        },
        {
            label: 'Interval End',
            value: record.intervalEndMillis,
            formatter: 'timestamp',
            span: 12,
        },
        {
            label: 'Columns',
            value: record.parameters.columns?.join(', ') as string,
            span: 12,
        }] : [];


    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>
            <PlatformPropertyCard properties={properties2}/>
            {parameterProperties.length > 0 && <PlatformPropertyCard properties={parameterProperties}/>}
        </Stack>
    );


};
